<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}过程管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实验实训过程导入模版</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="student_name" width="100" label="学生姓名">
        </custom-table-column>
        <custom-table-column prop="student_code" label="学号" width="120">
        </custom-table-column>
        <custom-table-column prop="course_project_name" :label="`${$store.state.themeTitle}项目`" min-width="180">
        </custom-table-column>
        <custom-table-column prop="period" :label="`${$store.state.themeTitle}课时数`" width="180">
        </custom-table-column>
        <custom-table-column prop="result" label="结果综合评价" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="start_time" label="开始日期" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="结束日期" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="774px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}项目`" prop="course_project_id">
          <el-select v-model="ruleForm.course_project_id" clearable filterable :placeholder="`请选择`" style="width:572px;"
            @change="handleProChange">
            <el-option v-for="item in projects" :key="item.id"
              :label="`${item.experiment_name}(${item.experiment_code})`" :value="item.id">
              <p>{{ item.experiment_name }}({{ item.experiment_code }})</p>
              <p v-if="item.instructor_name" class="el-option-tips">指导老师：{{ item.instructor_name }}</p>
              <p v-if="item.term" class="el-option-tips">学年学期：{{ item.term }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学 生" prop="student_id">
          <el-select v-model="ruleForm.student_id" style="width: 216px;" clearable filterable :loading="loading" remote
            :remote-method="remoteMethod" placeholder="请选择" @change="handleStudentChange">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">学号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}课时数`" prop="period">
          <el-input v-model="ruleForm.period" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开始日期" prop="start_time">
          <el-date-picker type="date" placeholder="选请择" value-format="yyyy-MM-dd" v-model="ruleForm.start_time"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="end_time">
          <el-date-picker type="date" placeholder="请选择" value-format="yyyy-MM-dd" v-model="ruleForm.end_time"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结果综合评价" prop="result">
          <el-input v-model="ruleForm.result" placeholder="请输入分数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinImport } from '@/assets/js/mixin/import';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinValidate,mixinImport],
  data() {
    return {
      formInline: {
      },
      levell: [1, 2],
      loading: false,
      ruleForm: {
        course_project_name: '',
        course_project_code: '',
        course_project_id: '',
        student_name: '',
        student_code: '',
        structure_1: '',
        structure_2: '',
        student_id: '',
        start_time: '',
        end_time: '',
        result: '',
        period: ''
      },
      rules: {
        order_user_dep: [{ required: true, message: '请选择院系或专业' }],
        period: [{ required: true, message: '请输入', trigger: 'blur' }],
        result: [{ required: true, message: '请输入', trigger: 'blur' },
        { validator: this.checkfloat, trigger: 'blur' }],
        start_time: [{ required: true, message: `请选择`, trigger: 'change' }],
        end_time: [{ required: true, message: `请选择`, trigger: 'change' }],
        student_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        course_project_id: [{ required: true, message: `请选择`, trigger: 'change' }],
      },
      projects: [],
      users: [],
      action: '',
      downloadUrl: 'template/实验实训过程导入模版.xlsx',
      downloadName: '实验实训过程导入模版.xlsx',
      btnTitle: '导入实验实训过程',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/training-processes/import`;
  },
  mounted() {
    this.remoteMethod()
    this.getProjects()
  },
  methods: {
    handleProChange(val) {
      const { experiment_name,course_project_code, structure_1, structure_2 } = this.$until.getLabelNameNew({ arr: this.projects, id: val })
      this.ruleForm.course_project_name = experiment_name;
      this.ruleForm.course_project_code = course_project_code;
      this.ruleForm.structure_1 = structure_1;
      this.ruleForm.structure_2 = structure_2;
    }, handleStudentChange(val) {
      const { name, number } = this.$until.getLabelNameNew({ arr: this.projects, valKeys: ['name', 'number'], id: val })
      this.ruleForm.student_code = number;
      this.ruleForm.student_name = name;
    },
    handleEditInit(row) {
      if (row.student_id && JSON.stringify(this.users).indexOf(row.student_id) == -1) {
        this.users.push({ id: row.student_id, name: row.student_name, number: row.student_code })
      }
    },
    async remoteMethod(query = '') {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: '4',
      };
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
      }
      this.loading = false;

    },
    async getProjects() {
      this.projects = []
      let params = {
        status: 2,
        page: 1,
        size: 9999
      }
      let res = await this.$api.instance.interfaceServer('api/course-projects/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.projects = res.data.data;
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training-processes/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/training-processes/store`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/training-processes/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training-processes/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
